// extracted by mini-css-extract-plugin
module.exports = {"gdprFaq":"GDPRFAQ-module--gdpr-faq--1Eyxl"};